package com.downdogapp.client

import com.downdogapp.*

object Stripe {

  private val stripe = js("window.Stripe('pk_live_Ap282MaMsTx3yewwSX0FIhUV')")

  fun promptPurchase(sessionId: String, onError: (String?) -> Unit) {
    stripe
      .redirectToCheckout(jsObj("sessionId" to sessionId))
      .then { result ->
        onError(result.error.message as String)
      }
  }
}
